module.exports = __webpack_public_path__ + "dimer/static/img/ProfPW.4b05f78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ProfPW.jpg
// module id = tTCj
// module chunks = 0